import { render, staticRenderFns } from "./signup-data.vue?vue&type=template&id=6a4f96da&scoped=true&"
import script from "./signup-data.vue?vue&type=script&lang=js&"
export * from "./signup-data.vue?vue&type=script&lang=js&"
import style0 from "./signup-data.vue?vue&type=style&index=0&id=6a4f96da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f96da",
  null
  
)

export default component.exports